export function presentTravelType(option) {
    var _a, _b, _c;
    return {
        ...option,
        iconUrl: String((_c = (_a = option.iconUrl) !== null && _a !== void 0 ? _a : (_b = option.raw) === null || _b === void 0 ? void 0 : _b.icon_url) !== null && _c !== void 0 ? _c : ''),
    };
}
export function presentTravelTypes(options) {
    return options.map(presentTravelType);
}
